import axios from 'axios';
import authService from './authService';
import { API_URL } from '@/config/api';

const api = axios.create({
  baseURL: API_URL,
  timeout: 10000,
});

api.interceptors.request.use(
    async (config) => {
      await authService.ensureAuthentication();
      config.headers = authService.getAuthHeaders();
      return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
      console.error('Erro na requisição API:', error.message);
      return Promise.reject(error);
    }
);

class ApiService {
  constructor(baseEndpoint) {
    this.baseEndpoint = baseEndpoint;
  }

  async get(endpoint = '', params = {}) {
    try {
      const response = await api.get(`${this.baseEndpoint}${endpoint}`, { params });
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar dados de ${this.baseEndpoint}${endpoint}:`, error);
      throw error;
    }
  }

  async post(endpoint, data) {
    try {
      const response = await api.post(`${this.baseEndpoint}${endpoint}`, data);
      return response.data;
    } catch (error) {
      console.error(`Erro ao criar registro em ${this.baseEndpoint}${endpoint}:`, error);
      throw error;
    }
  }

  async put(endpoint, data) {
    try {
      const response = await api.put(`${this.baseEndpoint}${endpoint}`, data);
      return response.data;
    } catch (error) {
      console.error(`Erro ao atualizar registro em ${this.baseEndpoint}${endpoint}:`, error);
      throw error;
    }
  }

  async delete(endpoint) {
    try {
      const response = await api.delete(`${this.baseEndpoint}${endpoint}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao excluir registro em ${this.baseEndpoint}${endpoint}:`, error);
      throw error;
    }
  }
}

class ProcessoService extends ApiService {
  constructor() {
    super('/processos');
  }

  async getProcessos() {
    try {
      return await this.get();
    } catch (error) {
      console.error('Erro ao buscar todos os processos:', error);
      return [];
    }
  }

  async buscarProcessos(termoBusca) {
    try {
      return await this.get('/buscar', { busca: termoBusca });
    } catch (error) {
      console.error('Erro ao buscar processos por termo:', error);
      return [];
    }
  }

  async getProcessoPorId(id) {
    try {
      return await this.get(`/${id}`);
    } catch (error) {
      console.error(`Erro ao buscar processo ${id}:`, error);
      return null;
    }
  }

  async getProcessosPorCliente(clienteId) {
    try {
      return await this.get(`/cliente/${clienteId}`);
    } catch (error) {
      console.error(`Erro ao buscar processos do cliente ${clienteId}:`, error);
      return [];
    }
  }

  async criarProcesso(processo) {
    try {
      return await this.post('', processo);
    } catch (error) {
      console.error('Erro ao criar processo:', error);
      return null;
    }
  }

  async atualizarProcesso(id, processo) {
    try {
      return await this.put(`/${id}`, processo);
    } catch (error) {
      console.error(`Erro ao atualizar processo ${id}:`, error);
      return null;
    }
  }

  async excluirProcesso(id) {
    try {
      return await this.delete(`/${id}`);
    } catch (error) {
      console.error(`Erro ao excluir processo ${id}:`, error);
      return false;
    }
  }
}

const processoServiceInstance = new ProcessoService();

const processoService = {
  getProcessos: () => processoServiceInstance.getProcessos(),
  buscarProcessos: (termo) => processoServiceInstance.buscarProcessos(termo),
  getProcessoPorId: (id) => processoServiceInstance.getProcessoPorId(id),
  getProcessosPorCliente: (clienteId) => processoServiceInstance.getProcessosPorCliente(clienteId),
  criarProcesso: (processo) => processoServiceInstance.criarProcesso(processo),
  atualizarProcesso: (id, processo) => processoServiceInstance.atualizarProcesso(id, processo),
  excluirProcesso: (id) => processoServiceInstance.excluirProcesso(id)
};

export default processoService;